import { render, staticRenderFns } from "./config_WinJiangPei.vue?vue&type=template&id=0dc15b07&scoped=true"
import script from "./config_WinJiangPei.vue?vue&type=script&lang=js"
export * from "./config_WinJiangPei.vue?vue&type=script&lang=js"
import style0 from "./config_WinJiangPei.vue?vue&type=style&index=0&id=0dc15b07&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0dc15b07",
  null
  
)

export default component.exports